import { appFormUtil } from 'modules/common';
import { StyledMultiPartUploadField } from 'modules/components/layer01';
import React from 'react';



export type UploadPlanSetFieldProps<T extends object, K extends keyof T = keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
  uploadInProgressFieldName: K;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: UploadPlanSetFieldProps<T>) => {


  return (
    <StyledMultiPartUploadField.FC
      fieldName={props.fieldName}
      isMultiUpload={true}
      form={props.form}
      isUploadingFieldName={props.uploadInProgressFieldName}
      uploadCountFieldName={'uploadCount' as keyof T}
    />
  );
};


